const qcNoteEN = {
    "view": {
        "message": {
            "releaseHasQCIssues": "Release {{releaseName}} has QC Issues, please edit the release for detailed QC Feedback, make required changes and resubmit!",
            "trackHasQCIssues": "Track {{trackName}} has QC Issues, please edit the track for detailed QC Feedback, make required changes and resubmit!",
        }
    }
};

export default qcNoteEN;